/**
 * InnerWallsPopover — cursor-following popover shown on partition (ściana działowa) hover in InfoMode.
 *
 * Partition paths in SVG carry no per-element data. The product-level `area_walls`
 * field aggregates all partitions for the whole apartment — so every partition
 * hover shows the same total area.
 */

import { useI18n } from '../../../../shared/i18n/useI18n.js'

import { buildInnerWallsItems } from '../../utils/popoverItems.js'

import { BottomSheet } from '../../../../shared/ui/BottomSheet/BottomSheet.jsx'
import { DataGrid } from '../../../../shared/ui/DataGrid/index.js'

import { HoverPopoverCard }     from './HoverPopoverCard.jsx'

/**
 * @param {object}              props
 * @param {number|null}         props.areaWalls  — product.area_walls (total partition area, m²)
 * @param {{x:number,y:number}} props.position   — seed cursor position for initial placement
 * @param {boolean}             props.isMobile   — indicates if the device is mobile
 * @param {boolean}             props.isOpen     — controls Popover visibility
 * @param {function}            [props.onClose]  — called by Popover on Escape / scroll
 */
export function InnerWallsPopover({ areaWalls, position, isMobile, isOpen, onClose }) {
  const { t } = useI18n()

  const items = buildInnerWallsItems(areaWalls, t)

  if (isMobile) {
    return (
      <BottomSheet isOpen={isOpen} onClose={onClose}>
        <BottomSheet.Header closeLabel={t('product.popover_close')}>
          <span>{t('product.partition_walls')}</span>
        </BottomSheet.Header>
        <BottomSheet.Content>
          <DataGrid items={items} columns={1} size="small" />
        </BottomSheet.Content>
      </BottomSheet>
    )
  }

  return (
    <HoverPopoverCard
      isOpen={isOpen}
      position={position}
      onClose={onClose}
      header={t('product.partition_walls')}
      items={items}
      maxColumns={1}
    />
  )
}
